export default class UserStore {
  constructor({ api, user, services }) {
    this.api = api;

    this.user = user;
    this.services = services;
  }

  get actions() {
    return {
      'sayl-oat.user/changeLang': this.changeLang.bind(this),
      'sayl-oat.user/view': this.view.bind(this),
      'sayl-oat.user/update': this.update.bind(this),
    }
  }

  get name() { 
    return 'sayl-oat.user';
  }

  get mutations() { 
    return {
      'sayl-oat.user/setUser': this.setUser.bind(this)
    };
  }

  get state() {
    return {
      user: this.user,
      services: this.services,
    };
  }

  setUser(state, user) {
    state.user = user;
  }

  changeLang({ state, commit }, locale) {
    return new Promise((resolve, reject) => {
      this.api.user.setLang({ locale }).then((user) => {
        commit('sayl-oat.user/setUser', user)
        resolve(user);
      }).catch(reject);
    });
  }

  update({ state, commit }, args){
    return new Promise((resolve, reject) => {
      this.api.user.put({ user: args }).then((result) => {
        commit('sayl-oat.user/setUser', result);
        resolve(result);
      }).catch(error => {
        reject(error);  
      });
    });
  }

  view({ commit }) {
    return new Promise((resolve, reject) => {
      this.api.user.view().then((result) => {
        commit('sayl-oat.user/setUser', result);
        resolve(result);
      }).catch(error => {
        reject(error);  
      });
    });
  }
}